import { cn } from '@/shared/lib/cn';

/**
 * As abas da plataforma, num padrao so: um seletor segmentado, com a aba aberta num
 * cartao branco na cor da empresa sobre o trilho cinza. As telas que desenham as
 * proprias abas (`role="tablist"`) usam estas classes, e `DetailTabs` tambem. O nome
 * da aba nao quebra: quando as abas nao cabem numa linha, o trilho passa para a de
 * baixo, em vez de espremer cada nome em tres linhas.
 */
export const trilhoDeAbas =
  'flex w-fit max-w-full flex-wrap gap-1 rounded-xl bg-ink-100 p-1 ring-1 ring-line ring-inset';

const base =
  'rounded-lg px-3 py-1.5 font-semibold whitespace-nowrap ' +
  'transition-[background-color,color,box-shadow] duration-(--duration-fast) ' +
  'focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand-500';

/** A classe da aba, aberta ou nao, no tamanho de texto da tela (`xs` ou `sm`). */
export function classeDaAba(aberta: boolean, tamanho: 'xs' | 'sm' = 'sm'): string {
  return cn(
    base,
    tamanho === 'xs' ? 'text-xs' : 'text-sm',
    aberta
      ? 'bg-surface text-brand-700 shadow-(--shadow-sm) ring-1 ring-line'
      : 'text-ink-600 hover:bg-surface/60 hover:text-ink-900',
  );
}
